module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.7056cf59.jpg";